import './Dashboard.css';

import { Button, Grid } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { TrackDashboardDelete, TrackDashboardView, TrackFilterClick, TrackGetQRClick, TrackQRScan } from 'utilities/insights';
import { useDispatch, useSelector } from 'react-redux';

import ActionsBar from './components/ActionsBar';
import AddContributorModal from './components/AddContributorModal';
import AddInfoModal from './components/AddInfoModal';
import AppLoader from 'components/Loader';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ContributorsHeader from './components/ContributorsHeader';
import DropdownMenu from './components/DropdownMenu';
import EditContributorModal from './components/EditContributorModal';
import EditDashboardModal from './components/EditDashboardModal';
import EditInfoModal from './components/EditInfoModal';
import FeedbackForm from './components/LinkFeedbackModal';
import GroupIcon from '@material-ui/icons/Group';
import InfoHeader from './components/InfoHeader';
import LinkAdd from './components/AddLinkModal';
import LinkCard from './components/LinkCard';
import LinkEdit from './components/EditLinkModal';
import LoginCard from './components/LoginCard';
import RequestLinkModal from './components/RequestLinkModal';
import Title from './components/Title';
import { deleteDashboard } from 'redux/thunks/dashboard';
import { getDashboard } from 'redux/thunks/dashboard';
import { resetDeletingDashboard } from 'redux/actions/dashboard';
import { resetGettingDashboard } from 'redux/actions/dashboard';
import swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const Dashboard = ({ match }) => {
    const { siteId, dashboardId } = match.params;
    const email = useSelector((state) => state.user.email);
    const userName = useSelector((state) => state.user.userName);
    const authenticated = useSelector((state) => state.user.authenticated);
    const dashboard = useSelector((state) => state.dashboard);
    const isAdmin = useSelector((state) => state.user.admin);
    const dispatch = useDispatch();

    const [loadedGroup, setLoadedGroup] = useState({ links: [], loaded: false, internalLinkCount: 0 });

    const [filterValue, setFilterValue] = useState('');
    const [filterOptions, setFilterOptions] = useState([]);

    const [isOwner, setIsOwner] = useState(false);
    const [isContributor, setIsContributor] = useState(false);

    const [showLinkRequest, setShowLinkRequest] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [addInfoModalOpen, setAddInfoModalOpen] = useState(false);
    const [editInfoModalOpen, setEditInfoModalOpen] = useState(false);
    const [addContributorModalOpen, setAddContributorModalOpen] = useState(false);
    const [editContributorModalOpen, setEditContributorModalOpen] = useState(false);
    const [editDashboardModalOpen, setEditDashboardModalOpen] = useState(false);
    const [showLinkEditModal, setShowLinkEditModal] = useState(false);
    const [showLinkEditRequestModal, setShowLinkEditRequestModal] = useState(false);

    const editingInfo = useRef();
    const editingLink = useRef();
    const editingContributor = useRef();
    const editingDashboard = useRef();
    const location = useLocation();
    const history = useHistory();

    const editInfoClicked = (info) => {
        setEditInfoModalOpen(true);
        editingInfo.current = info;
    };

    const editContributorClicked = (contributor) => {
        setEditContributorModalOpen(true);
        editingContributor.current = contributor;
    };

    const editDashboardClicked = () => {
        setEditDashboardModalOpen(true);
        editingDashboard.current = dashboard.selectedDashboard;
    };

    const handleDashboardDelete = async () => {
        const result = await swal.fire({
            title: 'Are you sure?',
            text: 'If you proceed, this dashboard will be deleted. The associated data will not be recoverable once deleted.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it.',
        });

        if (result.value) {
            const dashboard = {
                dashboardId: dashboardId,
                siteId: siteId,
            };

            TrackDashboardDelete(siteId);
            dispatch(deleteDashboard(dashboard));
        }
    };

    const handleGetQRClick = () => {
        TrackGetQRClick(siteId, dashboardId, userName);
        history.push(`/site/${siteId}/dashboard/${dashboardId}/qr-code`);
    };

    const onModifyLinkClicked = (event, link, canEdit) => {
        editingLink.current = link;

        if (canEdit) {
            setShowLinkEditModal(true);
        } else {
            setShowLinkEditRequestModal(true);
        }
        event.stopPropagation();
    };

    useEffect(() => {
        if (siteId && dashboardId) {
            TrackDashboardView(siteId, dashboardId, userName);
            dispatch(getDashboard(siteId, dashboardId));
        }
    }, [siteId, dashboardId, userName, dispatch]);

    useEffect(() => {
        if (dashboard.gettingDashboardSuccess) {
            dispatch(resetGettingDashboard());
        }
    }, [dashboard.gettingDashboardSuccess, dispatch]);

    useEffect(() => {
        if (Object.keys(dashboard.selectedDashboard).length > 0) {
            let selectedDashboard = dashboard.selectedDashboard;

            let ownerCheck = email && email === selectedDashboard.owner.email ? true : false;
            setIsOwner(ownerCheck);

            // check the list of contributors and see if the current user is there
            let contributorCheck =
                selectedDashboard.contributors && selectedDashboard.contributors.length > 0 && selectedDashboard.contributors.some((c) => c.email === email);
            setIsContributor(contributorCheck);

            //MARK AS INTERNAL
            let counter = 0;
            dashboard.selectedDashboard.links.forEach((link) => {
                if (link.isInternal) counter += 1;
            });

            //SORT THE LINKS
            const sorted_function_links = dashboard.selectedDashboard.links.sort((a, b) => {
                let fa = a.description.toLowerCase();
                let fb = b.description.toLowerCase();
                if (fa < fb) return -1;
                if (fa > fb) return 1;
                return 0;
            });

            //GENERATE CATEGORIES
            const filterOptions = [];
            for (var i = 0; i < sorted_function_links.length; i += 1) {
                if (filterOptions.indexOf(sorted_function_links[i].category) === -1) {
                    if (authenticated) {
                        filterOptions.push(sorted_function_links[i].category);
                    } else {
                        if (!sorted_function_links[i].isInternal) {
                            filterOptions.push(sorted_function_links[i].category);
                        }
                    }
                }
            }
            setFilterOptions(filterOptions);

            setLoadedGroup({
                links: sorted_function_links,
                loaded: true,
                internalLinkCount: counter,
            });
        }
    }, [dashboard.gettingDashboardSuccess, dashboard.selectedDashboard, authenticated, email]);

    //QR CODE TRACKING
    useEffect(() => {
        TrackQRScan(location, siteId, dashboardId, userName);
    }, [location, siteId, dashboardId, userName]);

    useEffect(() => {
        if (filterValue) {
            TrackFilterClick(siteId, filterValue, userName, email);
        }
    }, [filterValue, userName, email, siteId]);

    useEffect(() => {
        if (dashboard.deletingDashboardSuccess) {
            swal.fire({
                type: 'success',
                title: 'Success',
                text: 'Dashboard deleted successfully!',
                confirmButtonText: 'Ok',
            });
        }
    }, [dashboard.deletingDashboardSuccess, dispatch]);

    useEffect(() => {
        if (dashboard.deletingDashboardSuccess) {
            dispatch(resetDeletingDashboard());
            history.push(`/myDashboards`);
        }
    }, [dashboard.deletingDashboardSuccess, dispatch, history]);

    return (
        <>
            {!loadedGroup.loaded || dashboard.gettingDashboard ? (
                <AppLoader containerStyle={{ minHeight: '75vh' }} />
            ) : (
                <div className='page-container'>
                    <div className='top-buttons-wrapper'>
                        <div
                            className='back-button-container'
                            onClick={() => {
                                window.history.back();
                            }}
                        >
                            <ChevronLeftIcon className='left-arrow' fontSize='small' />
                            <div className='back-button'>Back</div>
                        </div>
                        {(isAdmin || isOwner || isContributor) && (
                            <DropdownMenu editDashboardClicked={() => editDashboardClicked()} deleteDashboardClicked={() => handleDashboardDelete()} />
                        )}
                    </div>
                    <div className='header'>
                        <Title
                            siteId={siteId}
                            dashboardId={dashboardId}
                            dashboardName={dashboard.selectedDashboard.name}
                            ownerName={dashboard.selectedDashboard.owner.name}
                            imageUrl={dashboard.selectedDashboard.imageUrl}
                            imageLoading={dashboard.deletingDashboardPhoto || dashboard.uploadingDashboardPhoto}
                            allowEdit={isAdmin || isOwner || isContributor}
                            email={dashboard.selectedDashboard.email}
                            hits={dashboard.selectedDashboard.hits}
                            contributors={dashboard.selectedDashboard.contributors}
                        />
                        <div className='right-section'>
                            {(isAdmin || isOwner) && (
                                <Button
                                    color='primary'
                                    size='small'
                                    variant='outlined'
                                    startIcon={<GroupIcon />}
                                    onClick={(e) => {
                                        setAddContributorModalOpen(true);
                                    }}
                                    className='contributor-btn'
                                >
                                    Add Contributor
                                </Button>
                            )}
                            <Button color='primary' size='small' variant='outlined' onClick={() => handleGetQRClick()} className='qr-btn'>
                                <div className='qr'>
                                    <svg aria-hidden='true' focusable='false' role='img' viewBox='0 0 448 512' className='qr__logo'>
                                        <path
                                            fill='currentColor'
                                            d='M0 224h192V32H0v192zM40 72h112v112H40V72zm216-40v192h192V32H256zm152 152H296V72h112v112zM0 480h192V288H0v192zm40-152h112v112H40V328zm32 32h48v48H72v-48zm0-256h48v48H72v-48zm304 48h-48v-48h48v48zm40 136h32v128H320v-32h-32v96h-32V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z'
                                        ></path>
                                    </svg>
                                </div>
                                Get QR
                            </Button>
                        </div>
                    </div>

                    {(isAdmin || isOwner) && (
                        <ContributorsHeader
                            addContributorClicked={() => setAddContributorModalOpen(true)}
                            editContributorClicked={editContributorClicked}
                            contributors={dashboard.selectedDashboard.contributors}
                            isOwner={isOwner}
                        />
                    )}

                    <InfoHeader
                        addInfoClicked={() => setAddInfoModalOpen(true)}
                        editInfoClicked={editInfoClicked}
                        info={dashboard.selectedDashboard.info}
                        isOwner={isOwner}
                        isContributor={isContributor}
                    />

                    <ActionsBar
                        siteId={siteId}
                        authenticated={authenticated}
                        isOwner={isOwner}
                        isContributor={isContributor}
                        filterOptions={filterOptions}
                        filterValue={filterValue}
                        userName={userName}
                        email={email}
                        set_filterValue={setFilterValue}
                        set_showLinkRequest={setShowLinkRequest}
                        set_showAddModal={setShowAddModal}
                    />

                    {/* LINKS */}
                    <div className='links-container'>
                        <Grid container spacing={2}>
                            {loadedGroup.links.map((link, index) => {
                                if (filterValue && filterValue.toLowerCase() !== link.category.toLowerCase()) {
                                    return null;
                                }

                                if (link.isInternal && !authenticated) {
                                    return null;
                                }

                                return (
                                    <Grid item xs={12} sm={3}>
                                        <LinkCard
                                            key={index}
                                            link={link}
                                            siteId={siteId}
                                            dashboardId={dashboardId}
                                            userName={userName}
                                            email={email}
                                            canEdit={isOwner || isContributor || isAdmin}
                                            onIconClick={
                                                isOwner || isContributor || isAdmin
                                                    ? (event) => onModifyLinkClicked(event, link, true)
                                                    : (event) => onModifyLinkClicked(event, link, false)
                                            }
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </div>

                    {/* LOGIN FOOTER */}
                    {!authenticated && loadedGroup.internalLinkCount > 0 && <LoginCard internalLinkCount={loadedGroup.internalLinkCount} />}

                    {/* MODALS */}

                    {showLinkEditModal && (
                        <LinkEdit
                            show={showLinkEditModal}
                            onClose={() => setShowLinkEditModal(false)}
                            siteId={siteId}
                            linkId={editingLink.current.linkId}
                            dashboardId={dashboardId}
                            description={editingLink.current.description}
                            category={editingLink.current.category}
                            author={editingLink.current.owner}
                            key={editingLink.current.linkId}
                            linkCategories={dashboard.selectedDashboard.links.map((link) => link.category)}
                        />
                    )}

                    {showLinkEditRequestModal && (
                        <FeedbackForm
                            show={showLinkEditRequestModal}
                            onClose={() => setShowLinkEditRequestModal(false)}
                            link={editingLink.current}
                            siteId={siteId}
                            owner_email={dashboard.selectedDashboard.owner.email}
                        />
                    )}

                    {showLinkRequest && (
                        <RequestLinkModal
                            show={showLinkRequest}
                            onClose={() => setShowLinkRequest(false)}
                            dashboardId={dashboardId}
                            siteId={siteId}
                            owner_email={dashboard.selectedDashboard.owner.email}
                        />
                    )}

                    {showAddModal && (
                        <LinkAdd
                            show={showAddModal}
                            dashboardId={dashboardId}
                            siteId={siteId}
                            linkCategories={dashboard.selectedDashboard.links.map((link) => link.category)}
                            onClose={() => setShowAddModal(false)}
                        />
                    )}
                    {addInfoModalOpen && (
                        <AddInfoModal
                            show={addInfoModalOpen}
                            info={dashboard.selectedDashboard.info}
                            dashboardId={dashboardId}
                            siteId={siteId}
                            onClose={() => setAddInfoModalOpen(false)}
                        />
                    )}

                    {editInfoModalOpen && (
                        <EditInfoModal
                            show={editInfoModalOpen}
                            info={editingInfo.current}
                            dashboardId={dashboardId}
                            siteId={siteId}
                            onClose={() => setEditInfoModalOpen(false)}
                        />
                    )}
                    {addContributorModalOpen && (
                        <AddContributorModal
                            show={addContributorModalOpen}
                            onClose={() => setAddContributorModalOpen(false)}
                            dashboardId={dashboardId}
                            siteId={siteId}
                        />
                    )}
                    {editContributorModalOpen && (
                        <EditContributorModal
                            show={editContributorModalOpen}
                            contributor={editingContributor.current}
                            dashboardId={dashboardId}
                            siteId={siteId}
                            onClose={() => setEditContributorModalOpen(false)}
                        />
                    )}
                    {editDashboardModalOpen && (
                        <EditDashboardModal
                            show={editDashboardModalOpen}
                            dashboard={editingDashboard.current}
                            dashboardId={dashboardId}
                            siteId={siteId}
                            onClose={() => setEditDashboardModalOpen(false)}
                            isAdmin={isAdmin}
                            isOwner={isOwner}
                        />
                    )}
                </div>
            )}
        </>
    );
};

export default Dashboard;
